import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Stack } from '../containers';
import { LoadingSpinner } from '../loaders';
import plusIcon from '../../img/plus-icon.svg';
import s from './Button.css';

const propTypes = {
    className: PropTypes.string,
    align: PropTypes.oneOf(['left', 'center', 'right']),
    design: PropTypes.oneOf(['yellow', 'blue', 'warning']),
    label: PropTypes.string.isRequired,
    withBox: PropTypes.bool,
    boxOnLeft: PropTypes.bool,
    boxIcon: PropTypes.string,
    isLoading: PropTypes.bool,
};

export class Button extends React.Component {
    static defaultProps = {
        align: 'center',
        design: 'yellow',
        withBox: false,
        boxOnLeft: false,
        boxIcon: plusIcon,
        isLoading: false,
    };

    render() {
        const { withBox, boxOnLeft, boxIcon, align, label, isLoading, ...buttonProps } = this.props;

        return (
            <button
                className={classNames(s.button, {
                    [s.left]: this.props.align === 'left',
                    [s.right]: this.props.align === 'right',
                    [s.blue]: this.props.design === 'blue',
                    [s.red]: this.props.design === 'warning',
                })}
                {...buttonProps}
            >
                {withBox && boxOnLeft === true ? this.renderBox() : null}

                <p>{label}</p>

                {withBox && boxOnLeft === false ? this.renderBox() : null}
            </button>
        );
    }

    renderBox() {
        const { boxIcon, isLoading } = this.props;

        return (
            <div className={s.boxContainer}>
                {(isLoading && <LoadingSpinner color="#FFFFFF" size={32} />) || <img src={boxIcon} alt="" />}
            </div>
        );
    }
}

Button.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/actions/Button.jsx